export const addiesaas = window.addiesaas || (window.addiesaas = {})

export const {
  frontend: {settings = {}} = {},
} = addiesaas

export const ready = (callback, prepend) => {
  const ad = window.addiesaas || (window.addiesaas = {})
  const addiesaasReady = ad.ready || (ad.ready = {callbacks: []})

  const callbacks = addiesaasReady.callbacks
  const readyType = typeof addiesaasReady
  if (readyType === 'function') {
    addiesaasReady(callback, true)
  } else {
    if (prepend) {
      callbacks.unshift(callback)
    } else {
      callbacks.push(callback)
    }
  }
}

export const beforeReady = (callback, prepend) => {
  const ad = window.addiesaas || (window.addiesaas = {})
  const addiesaasReady = ad.ready || (ad.ready = {callbacks: []})
  const callbacks = ad.beforeReady || (ad.beforeReady = [])
  const readyType = typeof addiesaasReady
  if (readyType === 'function') {
    addiesaasReady(callback, true)
  } else {
    if (prepend) {
      callbacks.unshift(callback)
    } else {
      callbacks.push(callback)
    }
  }
}

export default addiesaas
